export default "__VITE_ASSET__CL2_5Huv__"